export default "__VITE_ASSET__D5HS8g2N__"